<script setup lang="ts">
    import { IInteractionSummary } from '@/js/services/api/interaction/types';
    import { __ } from '@/js/stores/expressions';
    import { AstroidIcon } from '@lucide/vue';

    withDefaults(
        defineProps<{
            summary: IInteractionSummary;
            compactHeading?: boolean;
        }>(),
        { compactHeading: false }
    );
</script>
<template>
    <div class="w-full bg-primary-plum-50 rounded-lg p-5.5 flex flex-col gap-5">
        <div>
            <h2
                class="flex items-center gap-2"
                :class="compactHeading ? 'text-overline-sm text-gray-dark' : 'heading-md'"
            >
                <AstroidIcon
                    :class="compactHeading ? 'size-3.5' : 'size-4'"
                    class="text-primary-beet"
                />
                {{ __('interactions-ai-summary') }}
            </h2>
            <p class="text-body mt-2">{{ summary.summary ?? __('interactions-no-data') }}</p>
        </div>
        <div>
            <h2 class="text-overline-sm text-gray-dark">
                {{ __('interactions-contact-reason') }}
            </h2>
            <p class="text-body mt-2">
                {{ summary.reasonForContact ?? __('interactions-no-data') }}
            </p>
        </div>
        <div>
            <h2 class="text-overline-sm text-gray-dark">
                {{ __('interactions-solution') }}
            </h2>
            <p class="text-body mt-2">{{ summary.solution ?? __('interactions-no-data') }}</p>
        </div>
        <div>
            <h2 class="text-overline-sm text-gray-dark">
                {{ __('interactions-solved') }}
            </h2>
            <p class="text-body mt-2">{{ summary.solved === 'Y' ? __('yes') : __('no') }}</p>
        </div>
    </div>
</template>
